<template>
  <div>
    <z-mantenedor
      v-model="items"
      :campo-subtitulo-dialog="(utm) => $dayjs(utm.id + '01', 'YYYYMMDD').format('MMMM YYYY')"
      :campo-titulo-dialog="(utm) => 'UTM'"
      :headers="headers"
      :query="query"
      url="/pagos/utm"
      search-url="/pagos/utm/search"
      search-method="post"
      disable-delete
      disable-view
      height="350"
      search-inicial
      width="380"
      @created="$emit('notificar', 'La UTM fue creada')"
      @created:error="$emit('notificar:error', 'Error al intentar crear UTM.')"
      @updated="$emit('notificar', 'UTM guardada.')"
      @update:error="$emit('notificar:error', 'Error al intentar guardar.')"
    >
      <template #buscador="{ loading, search, create }">
        <v-form @submit.prevent="search">
          <v-card class="d-flex justify-space-between" flat>
            <v-select
              v-model="query.scopes[0].parameters[0]"
              :items="anos"
              dense
              label="Año"
              outlined
            />
            <v-spacer />
            <z-btn :loading="loading" class="mx-1" color="primary" outlined :disabled="!fechaBusqueda" @click="buscarAutomaticamente()"> Buscar valor UTM </z-btn>
            <z-btn :loading="loading" color="primary" outlined type="submit"> Actualizar </z-btn>
            <z-btn
              class="mx-1"
              :loading="loading"
              color="primary"
              outlined
              @click="create({ monto: '' })"
            >
              Crear
            </z-btn>
          </v-card>
          <v-card class="d-flex justify-space-between" flat>
            <v-date-picker v-model="fechaBusqueda" type="month" :show-current="true"></v-date-picker>
            <div v-if="busquedaUtmAutomaticaExitosa === false" class="text-right">
              <h3 class="py-2" style="color: red; margin-right: 20px;">{{ mensajeError }}</h3>
            </div>
            <div v-if="busquedaUtmAutomaticaExitosa === true">
              <h3 class="py-2" style="color: green; margin-right: 20px;">
                Valor UTM encontrado: {{ $formato.moneda(valorUtmEncontrado) }} con fecha ({{ fechaUtmEncontrado }})
              </h3>
              <z-btn
                class="mx-1"
                :loading="loading"
                color="primary"
                outlined
                @click="create({ monto: formatoConPunto(valorUtmEncontrado) })"
              >
                Crear usando el valor encontrado
              </z-btn>
            </div>
          </v-card>
        </v-form>
      </template>

      <template #form="{ accion, form, errors }">
        <v-row v-if="accion === 'create'">
          <v-col>
            <z-input-mes v-model="form.mes" :error-messages="errors.mes" label="Mes" outlined />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.monto"
              :error-messages="errors.monto"
              label="Monto"
              minlength="5"
              type="number"
              outlined
            />
          </v-col>
        </v-row>
      </template>
    </z-mantenedor>
  </div>
</template>

<script>
import ZBtn from '@/components/ZBtn'
import ZInputMes from '@/components/Input/ZInputMes'
import ZMantenedor from '@/components/ZMantenedor'

export default {
  components: { ZMantenedor, ZBtn, ZInputMes },
  data() {
    return {
      items: [],
      headers: [
        {
          text: 'Mes',
          value: 'id',
          formatter: (v) => this.$dayjs(v + '01', 'YYYYMMDD').format('MMMM YYYY'),
        },
        {
          text: 'Monto',
          value: 'monto',
          formatter: (v) => this.$formato.moneda(v),
        },
        {
          text: 'Última edición',
          value: 'updated_at',
          formatter: (v) => this.$dayjs(v).format('L LT'),
        },
      ],
      query: {
        scopes: {
          0: { name: 'ano', parameters: [2020] },
        },
        sort: {
          0: { field: 'id', direction: 'desc' },
        },
      },
      valorUtmEncontrado: null,
      fechaUtmEncontrado: null,
      busquedaUtmAutomaticaExitosa: null,
      fechaBusqueda: null,
      mensajeError: '',
    }
  },
  methods: {
    fechaFormateada(fecha) {
      return this.$dayjs(fecha).format('DD-MM-YYYY')
    },
    encontrarAno(fecha) {
      return this.$dayjs(fecha).format('YYYY')
    },
    formatoConPunto(numero) {
      return +('' + numero).replace(',', '.')
    },
    async buscarAutomaticamente() {
      const [anio, mes] = this.fechaBusqueda.split('-')

      this.loading = true
      try {
        const url = `pagos/utm-cmf/${anio}/${mes}`
        const response = await this.$axios.get(url);

        const respuestaConsulta = response.data.data;
        const utms = respuestaConsulta.UTMs || []
        if (utms.length <= 0) {
          this.valorUtmEncontrado = null
          this.fechaUtmEncontrado = null
          this.busquedaUtmAutomaticaExitosa = false
          this.mensajeError = 'No hay datos para la fecha seleccionada'
          return
        }
        this.valorUtmEncontrado = utms[0].Valor.replace('.', '')
        this.fechaUtmEncontrado = this.fechaFormateada(utms[0].Fecha)
        this.busquedaUtmAutomaticaExitosa = true
      } catch (error) {
        this.valorUtmEncontrado = null
        this.fechaUtmEncontrado = null
        this.busquedaUtmAutomaticaExitosa = false

        this.mensajeError = 'Error al buscar el UTM'
        if (error.response && error.response.status === 404) {
          this.mensajeError = 'No hay datos para la fecha seleccionada'
        }

      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    anoActual() {
      return parseInt(this.$dayjs().format('YYYY'))
    },
    anos() {
      const anos = []

      for (let ano = this.$dayjs().month() === 11 ? this.anoActual + 1 : this.anoActual ; ano >= 2012; ano--) {
        anos.push(ano)
      }
      return anos
    },
  },
  beforeMount() {
    this.query.scopes[0].parameters[0] = this.anoActual
  },
}
</script>
